import { EditableQuestion, QuestionType } from '../../components/Questionnaires/types';
import { v1 as uuid } from 'uuid';

export const isFollowUpQuestion = (question: EditableQuestion) => {
  return Boolean(question.parent_question_id) && Boolean(question.answer_id);
};

export const createEmptyQuestion = (sectionNumber: number = 1): EditableQuestion => ({
  _id: uuid(),
  question: '',
  type: QuestionType.SINGLE_RADIO_SELECTION,
  position: 0,
  section: sectionNumber,
  answers: [{ _id: uuid(), value: "" }],
  required: false
});

export const filterOutAnswer = (answers: string[], answerId: string) => {
  return answers.filter(answer => answer !== answerId);
};
